// extracted by mini-css-extract-plugin
export default {"page":"DO-z","cartModal":"EO-z","checkout":"FO-z","placeholder":"GO-z","account":"HO-z"};